import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import messages from '@locale/index'
import i18nUtil from './utils/i18n'
import isLogin from '@common/isLogin'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: i18nUtil.getLocale(),
  messages
})

// 将公共函数注册到全局对象上
Vue.prototype.$isLogin = isLogin

// 全局挂载 i18n 工具
Vue.prototype.$i18nUtil = i18nUtil

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

